import React from "react";
import "./footer.css";
import Logo from "../../assets/Logo.png";
import { FaEnvelope } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-acco-logo">
        <img src={Logo} alt="EIA Logo" className="footer-logo" />
        <h2>
          ENVIRONMENTAL INNOVATION
          <br />
          ASSOCIATION
        </h2>
      </div>
      <div className="footer-info">
        <div className="footer-left">
          <p>
            2027/8 ซอยเจริญกรุง 77 ถนนเจริญกรุง วัดพระยาไกร เขตบางคอแหลม
            <br />
            กรุงเทพมหานคร
          </p>
          <p>Tel: +66 92-256-8607</p>
          <p>Fax: +66 92-256-8607</p>
          <p>Mobile: +66 92-256-8607</p>
        </div>
        <div className="footer-right">
          <h3>Contact us</h3>
          <p>
            <FaEnvelope className="footer-icon" /> info@eiath.org
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
